import {get, patch} from "../helper/request";
import {LOAD_MORPHEUS_SETTING, UPDATE_MORPHEUS_SETTING} from "../redux_constants/morpheus.setting.constant";
import {error_manager} from "../helper/error_manager";
import {store} from "../helper/store";

export const loadMorpheusSetting = () => dispatch => {
	get(`/api/morpheus/settings/${JSON.parse(localStorage.getItem('morpheus_setting')).id}/`)
		.then(morpheusSetting => dispatch({
			type: LOAD_MORPHEUS_SETTING,
			morpheusSetting,
		}))
		.catch(error => error_manager("Error loading morpheus setting", error));
};

export const loadExistingMorpheusSetting = (morpheusSetting) => dispatch => {
	dispatch({
		type: LOAD_MORPHEUS_SETTING,
		morpheusSetting,
	})
};

export const updateMorpheusSetting = morpheusSetting => {
	patch(`/api/morpheus/settings/${JSON.parse(localStorage.getItem('morpheus_setting')).id}/`, morpheusSetting)
		.catch(error => error_manager("Error updating morpheus setting", error));
	// @priyanshu: dispatch the action to update the state without waiting for the response
	return {
		type: UPDATE_MORPHEUS_SETTING,
		morpheusSetting,
	};
};

export const updateServices = services =>
	updateMorpheusSetting({services});

export const updateKeyboardShortcuts = keyboard_shortcuts =>
	updateMorpheusSetting({keyboard_shortcuts});

export const updateConfigurations = viewer_configurations =>
	updateMorpheusSetting({viewer_configurations});

export const updateTileViewerState = tile_viewer_app_state =>
	updateMorpheusSetting({tile_viewer_app_state});

export const updateAbstractAppsInstalled = abstract_configs =>
	updateMorpheusSetting({abstract_configs});

export const updateCaseViewFilter = case_view_filter =>
	updateMorpheusSetting({case_view_filter});

export const updateSort = updated_value => updateMorpheusSetting({sorting: {...store.getState().morpheusSettingReducer.sorting, ...updated_value}})